import ListingPaymentCTA from './ListingPaymentCTA';
export default ListingPaymentCTA;